import React, { useRef } from "react";
import { FaLongArrowAltLeft } from "react-icons/fa";
import {
  _convertToColorFormat,
  convertToCssColor,
} from "../../utils/formatColorCode";
import { PiPencilSimpleSlash } from "react-icons/pi";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import { ColorPicker } from "primereact/colorpicker";

type ColourPickerProps = {
  openColorPicker: boolean;
  openUpload: boolean;
  post: string;
  setColorPicker: React.Dispatch<React.SetStateAction<boolean>>;
  handleSelectColor: (color: string | null) => void;
  colors: string[];
};

const ColourPicker: React.FC<ColourPickerProps> = ({
  openColorPicker,
  openUpload,
  post,
  setColorPicker,
  handleSelectColor,
  colors,
}) => {
  const [openSecondColor, setOpenSecondColor] = React.useState(false);
  const handleCloseColorPicker = () => {
    setColorPicker(false);
    setOpenSecondColor(false);
  };
  const [colours, setColours] = React.useState("");
  const containerRef = useRef<HTMLDivElement | null>(null);

  // console.log(`#${colours}`);
  const customColour = _convertToColorFormat(`#${colours}`);
  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenSecondColor(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div>
      <div
        className={`w-[41px] cursor-pointer h-[41px] justify-center rounded-md border-[1.12px] border-solid border-[#FFF] text-white items-center font-normal font-SegoeUI text-[19px] mt-2 shadow-[0px_0px_4.48px_0px_rgba(0,0,0,0.25)] relative ${
          openColorPicker ? "hidden" : "flex"
        } ${post.length >= 130 || openUpload ? "hidden" : "flex"}`}
        style={{
          background:
            "linear-gradient(180deg, #FFC619 0%, #EB459F 34.38%, #215759 75%, #2FF77A 100%)",
        }}
        onClick={() => setColorPicker(true)}
      >
        Ee
      </div>
      {openColorPicker && (
        <div className="w-full h-[68px] mt-2 px-3 bg-[#ECEBEB] transition ease-in-out duration-700 delay-75 rounded-3xl flex items-center justify-between overflow-x-scroll chatWrapper">
          <div
            onClick={handleCloseColorPicker}
            className="px-[11.5px] bg-[#EAEAEA] border-[1.12px] border-solid border-[#FFF] mx-3 flex items-center justify-center cursor-pointer h-[41px] rounded shadow-[0px_0px_4.48px_0px_rgba(0,0,0,0.25)]"
          >
            <FaLongArrowAltLeft />
          </div>
          <div
            onClick={() => handleSelectColor(null)}
            className="px-[11.5px] bg-white border-[1.12px] border-solid border-[#FFF] mx-3 flex items-center justify-center cursor-pointer h-[41px] rounded shadow-[0px_0px_4.48px_0px_rgba(0,0,0,0.25)]"
          >
            Def
          </div>
          {colors.map((colour, i) => {
            const color = _convertToColorFormat(colour);
            // console.log(color);
            const _cssFormatColor = convertToCssColor(color);
            // console.log(_cssFormatColor);
            return (
              <div
                className="px-[20.5px] mx-3 border-[1.12px] border-solid border-[#FFF] flex cursor-pointer h-[41px] rounded shadow-[0px_0px_4.48px_0px_rgba(0,0,0,0.25)]"
                style={{ backgroundColor: _cssFormatColor }}
                key={i}
                onClick={() => handleSelectColor(color)}
              ></div>
            );
          })}
          <div
            className="px-[11.5px] mx-3 border-[1.12px] border-solid border-[#FFF] flex justify-center bg-white items-center cursor-pointer h-[41px] rounded shadow-[0px_0px_4.48px_0px_rgba(0,0,0,0.25)]"
            onClick={() => setOpenSecondColor(!openSecondColor)}
          >
            <PiPencilSimpleSlash size={24} />
          </div>
          {openSecondColor && (
            <div className="absolute -right-[190px] top-10" ref={containerRef}>
              <ColorPicker
                format="hex"
                inline
                value={colours}
                onChange={(e) => {
                  if (typeof e.value === "string") {
                    setColours(e.value);
                  }
                }}
                onClick={() => handleSelectColor(customColour)}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ColourPicker;
